import { useState } from 'react';
import { SoundCloudRelease } from 'types/releases';
import { useAppDispatch, useAppSelector } from 'app/store';
import {
  getCurrentlyReplacingAudio,
  getDeleteReleaseLink,
  getRelease,
} from 'app/store/Releases/selectors';
import { deleteReleaseVersionEffect } from 'app/store/Releases/effects';
import { ContentContainerType } from 'types/enums';
import { DeleteVersionDialog } from 'app/components/Releases/DeleteVersionDialog';
import { ContentContainer } from 'app/components/Core';
import { AddReleaseVersionDialog } from '../AddReleaseVersionDialog';
import { ReleaseVersionsListComponent } from './ReleaseVersionsListComponent';

export interface DeleteVersion {
  versionGuid: string;
}

export const ReleaseVersionsList = () => {
  const dispatch = useAppDispatch();
  const release = useAppSelector(getRelease) as SoundCloudRelease;
  const currentlyReplacingAudio = useAppSelector(getCurrentlyReplacingAudio);
  const canDeleteRelease = Boolean(useAppSelector(getDeleteReleaseLink));
  const [deleteVersion, setDeleteVersion] = useState<{
    versionLabel?: string;
    versionGuid: string;
    songGuid: string;
  }>();

  const { versions = [], isReadyForExportReason } = release;

  const handleDeleteVersion = ({ versionGuid }: DeleteVersion) =>
    dispatch(deleteReleaseVersionEffect({ versionGuid })).unwrap();

  const isLoading = isReadyForExportReason === 'Processing';

  return (
    <>
      <ReleaseVersionsListComponent
        loading={isLoading}
        versions={versions}
        canDeleteRelease={canDeleteRelease}
        releaseGuid={release.guid}
        onDelete={setDeleteVersion}
        currentlyReplacingAudio={currentlyReplacingAudio}
      />
      <DeleteVersionDialog
        title="Delete Audio"
        versionLabel={deleteVersion?.versionLabel}
        onDelete={async () => {
          await handleDeleteVersion({
            versionGuid: deleteVersion?.versionGuid || '',
          });
        }}
        onClose={() => setDeleteVersion(undefined)}
      />
      <ContentContainer type={ContentContainerType.LIST}>
        <AddReleaseVersionDialog release={release} />
      </ContentContainer>
    </>
  );
};
